<template>
  <div class="license_container">
    <div
      class="wrapper"
      v-for="item in list"
      :key="item.id"
    >
      <router-link
        class="img_box"
        target="_blank"
        :to="item.path"
        :style="{backgroundImage: `url(${item.path})`}"
      ></router-link>
      <div
        class="text"
        :title="item.name"
      >{{ item.name }}</div>
    </div>
    <div class="em"></div>
    <div class="em"></div>
  </div>
</template>

<script>
export default {
  name: 'License',
  data () {
    return {
      list: [{
        id: Math.random().toString(),
        name: '营业执照',
        path: '/img/certificate/营业执照.jpg'
      }, {
        id: Math.random().toString(),
        name: '快递业务经营许可证',
        path: '/img/certificate/快递业务经营许可证.jpg'
      }, {
        id: Math.random().toString(),
        name: '报关注册登记证书',
        path: '/img/certificate/报关注册登记证书.jpg'
      }, {
        id: Math.random().toString(),
        name: '备案表',
        path: '/img/certificate/备案表.jpg'
      }, {
        id: Math.random().toString(),
        name: '一类货运',
        path: '/img/certificate/一类货运.jpg'
      }, {
        id: Math.random().toString(),
        name: '二类货运',
        path: '/img/certificate/二类货运.jpg'
      }, {
        id: Math.random().toString(),
        name: '邮政局批文',
        path: '/img/certificate/邮政局批文.jpg'
      }]
    }
  }
}
</script>

<style lang="scss" scoped>
.license_container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  .wrapper {
    margin-bottom: 20px;
    width: 300px;
    height: 400px;
    box-sizing: border-box;
    padding: 5px;
    border-radius: 3px;
    border: 1px solid #d6d6d6;
    .img_box {
      display: block;
      width: 290px;
      height: 360px;
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center center;
    }
    .text {
      height: 34px;
      font-size: 14px;
      line-height: 34px;
      text-align: center;
      overflow: hidden;
    }
    &:hover {
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    }
  }
  .em {
    width: 300px;
  }
}
</style>
